import type { ReactNode } from "react";
import type { LoaderFunctionArgs } from "react-router";
import { Outlet } from "react-router";

// CMS хранит language codes как lowercase (`en-ca`, `ru-ru`); BCP47-style
// `en-GB` тоже принимается для совместимости.
const LANG_FORMAT = /^[a-z]{2}(-[a-zA-Z]{2})?$/;

export const loader = ({ params }: LoaderFunctionArgs): null => {
  if (!params.lang || !LANG_FORMAT.test(params.lang)) {
    throw new Response("Not Found", { status: 404, statusText: "Not Found" });
  }
  return null;
};

export default function LangLayout(): ReactNode {
  return <Outlet />;
}
